import { StyleSheet } from 'react-native';
import { heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  orderContainerLarge: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#fff',
    marginBottom: '1%',
    width: '90%',
    alignSelf: 'center',
    justifyContent: 'space-around',
  },
  orderContainerSmall: {
    flex: 1,
    flexDirection: 'column',
    marginBottom: '1%',
    width: '90%',
    alignSelf: 'center',
  },
  orderDataLarge: {
    flex: 0.5,
    flexDirection: 'column',
    marginBottom: '5%',
    marginLeft: '10%',
  },
  orderDataSmall: {
    flex: 1,
    width: '100%',
    marginBottom: '5%',
  },
  containerLarge: {
    width: '60%',
    marginTop: '5%',
    marginBottom: '7%',
    paddingVertical: '5%',
    paddingHorizontal: '5%',
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
  },
  containerSmall: {
    marginTop: '5%',
    marginBottom: '2%',
    paddingTop: '5%',
    paddingBottom: '5%',
    justifyContent: 'center',
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
  },
  rowCtn: {
    paddingLeft: '5%',
    paddingRight: '2%',
  },
  dataRowLarge: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '3%',
    marginBottom: '2%',
  },
  dataRowSmall: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: '5%',
    paddingRight: '5%',
    marginTop: '3%',
    marginBottom: '2%',
  },
  itemTextLarge: {
    color: '#000000',
    fontWeight: '400',
    fontSize: 14,
    marginLeft: '3%',
    lineHeight: 16,
    textAlign: 'right',
    justifyContent: 'flex-end',
    marginBottom: hp('1.5%'),
  },
  itemTextSmall: {
    color: '#000000',
    fontWeight: '400',
    fontSize: 14,
    marginLeft: '3%',
    lineHeight: 16,
    letterSpacing: 0,
    justifyContent: 'flex-end',
    textAlign: 'right',
  },
  itemTextProduct: {
    color: '#000000',
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 0,
    textAlign: 'left',
    alignSelf: 'flex-start',
  },
  itemTextTotalProduct: {
    fontWeight: '700',
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 0,
    textAlign: 'left',
    alignSelf: 'flex-start',
  },
  deliveryTextSmall: {
    flex: 1,
  },
  headerTextLarge: {
    color: '#000000',
    fontWeight: '600',
    fontSize: 14,
    lineHeight: 16,
    textAlign: 'left',
    justifyContent: 'flex-start',
    marginBottom: hp('1.5%'),
  },
  headerTextSmall: {
    color: '#000000',
    fontWeight: '600',
    fontSize: 14,
    lineHeight: 16,
  },
  orderProductsLarge: {
    flex: 1,
    width: '25%',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginBottom: '5%',
    marginRight: '10%',
    height: 'max-content',
  },
  orderProductsSmall: {
    flex: 1,
    marginBottom: '5%',
  },
  productsContainerLarge: {
    flex: 0.25,
    width: '65%',
    marginTop: '5%',
    paddingVertical: '5%',
    paddingHorizontal: '5%',
    justifyContent: 'center',
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
  },
  productsContainerSmall: {
    flex: 1,
    justifyContent: 'center',
    marginTop: '5%',
    paddingVertical: '5%',
    paddingHorizontal: '5%',
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
  },
  headerRow: {
    alignSelf: 'center',
  },
  productsHeaderText: {
    fontWeight: 'bold',
  },
  sectionContainerTitleSmall: {
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
  },
  sectionContainerTitleLarge: {
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    alignSelf: 'flex-start',
  },
  rowLarge: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: '5%',
  },
  rowSmall: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: '2%',
  },
  rowTotalLarge: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '5%',
    paddingLeft: '5%',
  },
  rowTotalSmall: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '3%',
    paddingLeft: '5%',
  },
  totalPrice: {
    marginTop: '15%',
  },
  whatsappIconLarge: {
    fontSize: 8,
    backgroundColor: '#25d366',
    alignSelf: 'flex-start',
    borderWidth: 0,
    borderRadius: 20,
    marginLeft: 15,
  },
  whatsappIconSmall: {
    fontSize: 8,
    alignSelf: 'flex-end',
    backgroundColor: '#25d366',
    borderWidth: 0,
    borderRadius: 20,
    marginLeft: 15,
  },
});
